var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutline2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.416667,
    y: 0.416667,
    width: 29.1667,
    height: 32.5,
    rx: 2.91667,
    stroke: "#DEDDE6",
    strokeWidth: 0.833333
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16699,
    y: 5.83337,
    width: 21.6667,
    height: 2.5,
    rx: 0.833333,
    fill: "#ACAAB7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16699,
    y: 12.5001,
    width: 15,
    height: 2.5,
    rx: 0.833333,
    fill: "#ACAAB7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16699,
    y: 25.8334,
    width: 15,
    height: 2.5,
    rx: 0.833333,
    fill: "#ACAAB7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16699,
    y: 19.1667,
    width: 21.6667,
    height: 2.5,
    rx: 0.833333,
    fill: "#ACAAB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutline2);
export default __webpack_public_path__ + "static/media/Outline_2.f746dfa14b0060b9365eea48ceed2155.svg";
export { ForwardRef as ReactComponent };